import { forwardRef, HTMLAttributes, Ref } from 'react';
import { Typography } from '@weareopenr/component-library';
import styles from './AutocompleteOptionWithRanges.module.scss';

interface OptionWithRanges {
  name: string;
  ranges?: { name: string }[];
}

interface AutocompleteOptionWithRangesProps extends HTMLAttributes<HTMLLIElement> {
  option: OptionWithRanges;
}

export const AutocompleteOptionWithRanges = forwardRef(
  ({ option, ...props }: AutocompleteOptionWithRangesProps, ref: Ref<HTMLLIElement>) => {
    const rangeNames = option.ranges?.map((range) => range.name);

    return (
      <li {...props} ref={ref} className={styles['list-option']}>
        <div className={styles['option-content']}>
          <Typography size="medium">
            <span title={option.name}>{option.name}</span>
          </Typography>
          {rangeNames && rangeNames.length > 0 ? (
            <Typography size="small" className={styles['range-subtitle']}>
              <span title={rangeNames.join('\r\n')}>{rangeNames.join(', ')}</span>
            </Typography>
          ) : (
            <Typography size="small" className={styles['no-range']}>
              No Range
            </Typography>
          )}
        </div>
      </li>
    );
  },
);

AutocompleteOptionWithRanges.displayName = 'AutocompleteOptionWithRanges';
